import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import SectionContent from 'Webapp/shared/app/containers/section/content';
import PageClasses from '../../components/page-classes';

import connector from 'Utils/connector';
import connectAmp from 'Webapp/shared/app/connectors/connectAmp';

function DefaultSectionView({
  section,
  items,
  contributors,
  isLoading,
  neverLoadMore,
  loadNextPage,
  isAmp,
  topicDescriptions,
  enableFullWidth,
  includeHeader,
}) {
  const pageClasses = classNames({
    'section-view': true,
    'profile-view': section && section.isProfile,
    amp: isAmp,
  });

  return (
    <React.Fragment>
      <PageClasses className={pageClasses} enableFullWidth>
        <div className={classNames({ 'centered-column': enableFullWidth })}>
          <SectionContent
            section={section}
            items={items}
            contributors={contributors}
            isLoading={isLoading}
            neverLoadMore={neverLoadMore}
            loadNextPage={loadNextPage}
            topicDescriptions={topicDescriptions}
            includeHeader={includeHeader}
          />
        </div>
      </PageClasses>
    </React.Fragment>
  );
}

DefaultSectionView.propTypes = {
  section: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  contributors: PropTypes.array,
  neverLoadMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadNextPage: PropTypes.func,
  isAmp: PropTypes.bool.isRequired,
  topicDescriptions: PropTypes.array,
  enableFullWidth: PropTypes.bool,
  includeHeader: PropTypes.bool,
};

DefaultSectionView.defaultProps = {
  contributors: [],
  topicDescriptions: [],
  enableFullWidth: false,
  includeHeader: true,
};

export default connector(connectAmp)(DefaultSectionView);
